<template>
  <layout-panel>
    <template slot="header">2. 分配给复核人</template>
    <div class="assign-diff-bar">
      <span class="assign-diff-item">预计单量合计：<strong>{{ totalExpected }}</strong></span>
      <span class="assign-diff-item">实际分配合计：<strong>{{ totalAssignedCount }}</strong></span>
      <span class="assign-diff-item">差额：<strong>{{ assignDiffDisplay }}</strong></span>
      <el-tag v-if="assignDiff === 0"
              type="success"
              size="small">可分配</el-tag>
      <el-tag v-else-if="assignDiff < 0"
              type="warning"
              size="small">尚余 {{ -assignDiff }} 单未分配</el-tag>
      <el-tag v-else
              type="danger"
              size="small">超出预计 {{ assignDiff }} 单</el-tag>
    </div>
    <el-table :data="reviewerList"
              stripe
              border
              style="width: 100%">
      <el-table-column prop="name"
                       label="复核人">
      </el-table-column>
      <el-table-column :label="reviewTargetColumnLabel"
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.target != null && scope.row.target !== '' ? scope.row.target + '单' : '-' }}
        </template>
      </el-table-column>
      <el-table-column :label="`复核单量(总计${totalAssignedCount})`"
                       align="center">
        <template slot-scope="scope">
          <el-input v-model="scope.row.assignedCount"
                    type="number"
                    size="small"
                    min="0"
                    step="1"
                    @input="onReviewerAssignedChange(scope.row)">
          </el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       align="center"
                       fixed="right">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="removeReviewer(scope.$index)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="margin t15 reviewer-toolbar">
      <el-button type="primary"
                 icon="el-icon-plus"
                 @click="openAddReviewerDialog">添加复核人</el-button>
      <el-button type="success"
                 icon="el-icon-s-operation"
                 :disabled="reviewerList.length === 0"
                 @click="applyAverageDistribution">一键平均复核单量</el-button>
    </div>

    <!-- 选择复核人弹窗：弹窗内为下拉搜索框 -->
    <el-dialog title="选择复核人"
               :visible.sync="addReviewerDialogVisible"
               width="720px"
               custom-class="add-reviewer-dialog"
               @open="onAddReviewerDialogOpen"
               @closed="onAddReviewerDialogClosed">
      <el-form label-width="110px">
        <el-form-item label="选择复核人：">
          <remote-select v-model="selectedReviewerInDialog"
                         class="dialog-select-width"
                         clearable
                         multiple
                         id-key="id"
                         keyword-key="name"
                         label-key="name"
                         value-key="id"
                         placeholder="请输入用户名称搜索"
                         :query-request="queryPlatformUsers"
                         :find-request="findPlatformUser">
          </remote-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="addReviewerDialogVisible = false">取消</el-button>
        <el-button type="primary"
                   @click="confirmAddReviewer">确定</el-button>
      </span>
    </el-dialog>
  </layout-panel>
</template>

<script>
import { getPlatformUsersIndex, getPlatformUsersDetail } from '@/views/platform-user/platform-user.api'
import { getReviewPlanQuery } from '@/views/order/order.api'

export default {
  name: 'ReviewerAssignPanel',
  props: {
    totalExpected: {
      type: Number,
      default: 0
    },
    reviewTargetDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      reviewerList: [],
      addReviewerDialogVisible: false,
      selectedReviewerInDialog: []
    }
  },
  computed: {
    totalAssignedCount () {
      return this.reviewerList.reduce((sum, row) => sum + (Number(row.assignedCount) || 0), 0)
    },
    totalTarget () {
      return this.reviewerList.reduce((sum, row) => sum + (Number(row.target) || 0), 0)
    },
    reviewTargetColumnLabel () {
      const date = this.reviewTargetDate || ''
      const base = date ? `复核目标(${date})` : '复核目标'
      return `${base}(总计${this.totalTarget})`
    },
    /** 实际分配合计 − 预计单量合计；0 为一致 */
    assignDiff () {
      return this.totalAssignedCount - (Number(this.totalExpected) || 0)
    },
    assignDiffDisplay () {
      const d = this.assignDiff
      if (d === 0) return '0'
      return d > 0 ? `+${d}` : String(d)
    }
  },
  methods: {
    /** 按当前「预计单量合计」在复核人之间平均整数分配（除不尽时余数归最后一人） */
    applyAverageDistribution () {
      const n = this.reviewerList.length
      if (n === 0) {
        this.$message.warning('请先添加复核人')
        return
      }
      const total = Math.max(0, Math.floor(Number(this.totalExpected) || 0))
      const base = Math.floor(total / n)
      const rem = total % n
      this.reviewerList.forEach((row, i) => {
        const val = i === n - 1 ? base + rem : base
        this.$set(row, 'assignedCount', String(val))
      })
      this.$message.success('已按预计单量平均分配复核单量')
    },
    setAssignedCount (target) {
      if (target === '' || target == null) return
      const raw = String(target).replace(/\D/g, '')
      const val = raw === '' ? '' : String(parseInt(raw, 10) || 0)
      this.reviewerList.forEach(row => {
        this.$set(row, 'assignedCount', val)
      })
    },
    removeReviewer (index) {
      this.reviewerList.splice(index, 1)
    },
    onReviewerAssignedChange (row) {
      const raw = String(row.assignedCount != null ? row.assignedCount : '').replace(/\D/g, '')
      this.$set(row, 'assignedCount', raw === '' ? '' : raw)
    },
    openAddReviewerDialog () {
      this.addReviewerDialogVisible = true
    },
    onAddReviewerDialogOpen () {
      this.selectedReviewerInDialog = []
    },
    onAddReviewerDialogClosed () {
      this.selectedReviewerInDialog = []
    },
    queryPlatformUsers (params) {
      return getPlatformUsersIndex(params || {}).then(res => {
        const body = res && res.data
        let list = []
        if (body && body.detail && Array.isArray(body.detail.data)) {
          list = body.detail.data
        } else if (body && Array.isArray(body.data)) {
          list = body.data
        }
        return { data: { data: list } }
      })
    },
    findPlatformUser (params) {
      return getPlatformUsersDetail(params || {})
    },
    getPlanDateToday () {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    parseReviewPlanTarget (res) {
      if (!res || res.data == null) return 0
      const data = res.data
      if (data.target != null && data.target !== '') {
        const n = Number(data.target)
        return Number.isNaN(n) ? 0 : n
      }
      const detail = data.detail
      if (Array.isArray(detail)) {
        if (detail.length === 0) return 0
        return detail.reduce((sum, row) => {
          if (!row || row.review_target == null || row.review_target === '') return sum
          const n = Number(row.review_target)
          return sum + (Number.isNaN(n) ? 0 : n)
        }, 0)
      }
      if (detail && typeof detail === 'object' && detail.target != null) {
        const n = Number(detail.target)
        return Number.isNaN(n) ? 0 : n
      }
      return 0
    },
    confirmAddReviewer () {
      const raw = this.selectedReviewerInDialog
      const ids = Array.isArray(raw) ? raw : (raw != null ? [raw] : [])
      const selectedIds = ids.map(item => (item != null && typeof item === 'object' && item.id != null ? item.id : item)).filter(id => id != null && id !== '')
      if (selectedIds.length === 0) {
        this.addReviewerDialogVisible = false
        return
      }
      const existingIds = this.reviewerList.map(r => r.id).filter(Boolean)
      const toAddIds = selectedIds.filter(id => existingIds.indexOf(id) === -1)
      if (toAddIds.length === 0) {
        this.$message.warning('所选用户已在复核人列表中')
        this.addReviewerDialogVisible = false
        return
      }
      const planDate = this.getPlanDateToday()
      const promises = toAddIds.map(id => {
        const detailPromise = getPlatformUsersDetail({ id: id })
          .then(res => {
            const data = res && res.data
            const name = (data && data.name) ||
              (data && data.detail && data.detail.name) ||
              (data && data.data && data.data.name) ||
              (data && data.detail && data.detail.data && data.detail.data.name)
            return (name != null && name !== '') ? String(name) : '-'
          })
          .catch(() => String(id))
        const planPromise = getReviewPlanQuery({ admin_id: id, plan_date: planDate })
          .then(res => this.parseReviewPlanTarget(res))
          .catch(() => 0)
        return Promise.all([detailPromise, planPromise]).then(([name, target]) => ({
          id: id,
          name: name,
          target: target,
          assignedCount: ''
        }))
      })
      Promise.all(promises).then(users => {
        users.forEach(u => {
          this.reviewerList.push({
            id: u.id,
            name: u.name,
            target: u.target,
            assignedCount: u.assignedCount
          })
        })
        this.addReviewerDialogVisible = false
        this.selectedReviewerInDialog = []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.assign-diff-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #f4f4f5;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;

  .assign-diff-item strong {
    color: #303133;
    font-weight: 600;
  }
}

.reviewer-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.dialog-select-width {
  width: 100%;
}

.add-reviewer-dialog /deep/ .el-dialog__body {
  padding: 24px 28px 28px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/ReviewerAssignPanel.vue